<template>
  <div
    id="closest"
    class="main-tab-content"
  >
    <div>
      <h3>最近的巴士站</h3>
    </div>
    <div class="row">
      <Autocomplete
        :debounce="800"
        :on-select="selectListItem"
        :on-should-get-data="getClosest"
        :on-should-render-child="printClosestItem"
        :url="autocompleteUrl"
        anchor="title"
        class="form-control"
        label="writer"
        placeholder=""
      >
      </Autocomplete>
    </div>

    <div class="spacer-10"></div>

    <div class="row">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Autocomplete from 'vue2-autocomplete-js';
import {ROUTE_SUGGEST, STOP_SUGGEST} from "../../config/paths/apiPaths";
import {mapActions, mapMutations} from "vuex";
import locationPromise from "../../config/location/locationPromise";
// import nearbyRoutes from "../../store/nearbyRoutes";


export default {
  name: "Closest",
  components: {
    Autocomplete,
  },
  data() {
    return {
      autocompleteUrl: ROUTE_SUGGEST,
    };
  },
  computed: {},
  methods: {
    ...mapMutations('nearbyRoutes', ['setUserLocation']),
    ...mapActions('nearbyRoutes', ['getNearbyRouteList']),

    getClosest(stopName) {
      return fetch(`${STOP_SUGGEST}?q=${stopName}`)
        .then(response => response.json())
        .then(json => json.data);
    },
    selectListItem(data) {
      this.$router.push({
        path: `/routeinfo/stopGroup/${data.stop_group_id}`
      });
    },
    printClosestItem(data) {
      return `
        <a>
            <span>${data.stop_name}</span>
        </a>
      `;
    },
    getGeoLocation() {
      console.log("CLOSEST GET GEOLOCATION");

      return locationPromise();
    },

  },
  mounted() {
    const nearbyRoutes = this.getNearbyRouteList;
    const setUserLocation = this.setUserLocation;

    console.log(nearbyRoutes);
    console.log("GOING TO GET GEO LOCATION");

    this.getGeoLocation()
      .then(location => {
        console.log("RETRIEVED GEO LOCATION");
        setUserLocation(location);

        nearbyRoutes(location);
      });
  },

}
</script>

<style scoped>

</style>
